import React, { Component } from 'react';
import { Container, Form, Col, Button, Table, Modal, InputGroup } from 'react-bootstrap';
import axios from 'axios'
import { Redirect } from 'react-router-dom'

import { AdminNav, RequestModal, Loading } from '../../helpers';

import { convertRiceTypeENToTH, addCommaInNumber } from '../../helpers/function'

class Requested extends Component {
  constructor(props) {
    super(props);
    this.state = {
      licenseID: '',
      history: [],
      riceTypeIDAndName: [],
      rawData: null,
      rawLicenseData: null,
      noteData: ''
    }
    this.handleHistorySearch = this.handleHistorySearch.bind(this)
    this.handleHistorySearchSubmit = this.handleHistorySearchSubmit.bind(this)
    this.handleNoteData = this.handleNoteData.bind(this)
  }
  componentDidMount() {
    let viewAllRiceTypeIDAndNamePromise = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      return res.json()
    })
    Promise.all([viewAllRiceTypeIDAndNamePromise]).then((res) => {
      viewAllRiceTypeIDAndNamePromise = res[0].data
      this.setState({
        ...this.state,
        riceTypeIDAndName: viewAllRiceTypeIDAndNamePromise
      })
    }).catch(() => {
      this.setState({
        ...this.state,
        riceTypeIDAndName: []
      })
    })
  }
  handleHistorySearch(e) {
    this.setState({
      ...this.state,
      licenseID: `${e.target.value}`,
    })
  }

  handleNoteData(e) {
    this.setState({
      ...this.state,
      noteData: `${e.target.value}`,
    })
  }

  handleHistorySearchSubmit() {
    axios.post(
      'https://backend1.riceinspections.com/testCB',
      {
        data: { 'licenseID': this.state.licenseID },
      }
    ).then((res) => {
      // console.log(res.data)
      let data = res.data
      if (Object.values(data).length != 0) {

        axios.post(
          'https://backend1.riceinspections.com/testFF',
          {
            data: data
          }
        ).then((snap) => {
          axios.get(
            `https://backend2.riceinspections.com/search?code=${this.state.licenseID}`
          ).then((rawLicenseData) => {
            axios.post(
              'https://backend1.riceinspections.com/viewNoteLicense',
              {
                data: {
                  'licenseID': this.state.licenseID
                }
              }
            ).then((newRes) => {
              this.setState({
                ...this.state,
                history: Object.values(data),
                rawData: Object.values(snap.data),
                rawLicenseData: rawLicenseData['data'],
                noteData: newRes?.data[0]?.noteData
              })
            })
          })
        })
      } else if (Object.values(data).length == 0) {
        this.setState({
          ...this.state,
          history: []
        }, () => { alert('ไม่พบประวัติ') })
      }
    }).catch((err) => {
      this.setState({
        ...this.state,
        history: []
      }, () => { alert('ไม่พบประวัติ') })
    })
  }
  renderExtra(arr) {
    if (this.state.rawData) {

      function renderExpireDate(exp) {
        let years = exp?.slice(exp.length - 4, exp.length)

        if(parseInt(years) > 2100){
          return `${exp?.slice(0, exp.length - 4)}${years}`    
        }else{
          years = parseInt(years) + 543
          return `${exp?.slice(0, exp.length - 4)}${years}`  
        }
      }
      return (
        <div>


          <Table bordered hover style={{ tableLayout: 'fixed' }}>

            <thead>
              <tr>
                <th style={{ overflow: 'auto', fontSize: '18px' }}>ใบอนุญาตเลขที่ </th>
                <th></th>
                <th style={{ overflow: 'auto', fontSize: '18px' }}>วันหมดอายุ </th>
                <th>{renderExpireDate(this.state.rawLicenseData['ExpiredDate'])}</th>
              </tr>
              <tr>
                <th style={{ overflow: 'auto', fontSize: '18px' }}>รายการที่ </th>
                <th>น้ำหนักสุทธิ</th>
                <th style={{ overflow: 'auto', fontSize: '18px' }}>สกุลเงิน </th>
                <th>อัตราแลกเปลี่ยน</th>
                <th>ราคาต่อหน่วย</th>
              </tr>

            </thead>
            <tbody>
              {(() => {

                if (Array.isArray(this.state.rawLicenseData['PaperlessDetail']['LicenseDetail'])) {
                  return (Object.values(this.state.rawLicenseData['PaperlessDetail']['LicenseDetail']).map((insideData, subID) => {

                    let KGM = insideData['NetWeightKGM']
                    if (!Number.isFinite(KGM)) {
                      KGM = parseFloat(KGM.replace(',', ''))
                    }

                    return (
                      <tr id={0}>
                        <td style={{ width: '13.7%', fontSize: '13px' }}><b>({parseInt(subID) + 1})</b></td>
                        <td style={{ width: '13.7%', fontSize: '13px' }}><b>{addCommaInNumber(parseFloat(KGM).toFixed(4))}/{insideData['Quantity']} {insideData['QuantityUnit']}</b></td>
                        <td style={{ width: '13.7%', overflow: 'auto', fontSize: '13px' }}><b > {'USD'} </b></td>
                        <td style={{ width: '13.7%', overflow: 'auto', height: '100%', fontSize: '13px' }}><b>{this.state.rawLicenseData['ExchangeRate']}</b></td>
                        <td style={{ overflow: 'auto', width: '13.7%', fontSize: '13px' }}><b>{insideData['PricePerUnit']}</b></td>
                      </tr>
                    )
                  }))
                } else {
                  let newArray = [this.state.rawLicenseData['PaperlessDetail']['LicenseDetail']]
                  return (Object.values(newArray).map((insideData, subID) => {
                    let KGM = insideData['NetWeightKGM']
                    if (!Number.isFinite(KGM)) {
                      KGM = parseFloat(KGM.replace(',', ''))
                    }

                    return (
                      <tr id={0}>
                        <td style={{ width: '13.7%', fontSize: '13px' }}><b>({parseInt(subID) + 1})</b></td>
                        <td style={{ width: '13.7%', fontSize: '13px' }}><b>{addCommaInNumber(parseFloat(KGM).toFixed(4))}/{insideData['Quantity']} {insideData['QuantityUnit']}</b></td>
                        <td style={{ width: '13.7%', overflow: 'auto', fontSize: '13px' }}><b > {'USD'} </b></td>
                        <td style={{ width: '13.7%', overflow: 'auto', height: '100%', fontSize: '13px' }}><b>{this.state.rawLicenseData['ExchangeRate']}</b></td>
                        <td style={{ overflow: 'auto', width: '13.7%', fontSize: '13px' }}><b>{insideData['PricePerUnit']}</b></td>
                      </tr>
                    )
                  }))
                }
              })()
              }
            </tbody>
          </Table>
          หมายเหตุ
          <InputGroup>
            <Form.Control id={`noteData`}
              onChange={(e) => { this.handleNoteData(e) }}
              value={this.state.noteData} />
          </InputGroup>
          <br />
          <Button onClick={() => { this.saveNote(this.state.noteData, this.state.licenseID) }}> บันทึกหมายเหตุ </Button>
        </div>)
    }
  }
  calculateSumWeight(arr, subID) {
    if (Number.isFinite(subID)) {
      let sumWeight = 0
      arr.map((insideSubData) => {
        if (insideSubData['checkweightData']['subID'] == subID) {
          sumWeight += (parseFloat(insideSubData['checkweightData']['quantity']) / 1000)
        }
      })
      return sumWeight
    }
  }
  calculateWeightLeft(sumWeight, rawData, subID) {
    console.log(sumWeight, rawData)
    if (Array.isArray(rawData)) {
      return Object.values(rawData)[subID]['NetWeightTON'] - sumWeight
    } else {
      return rawData?.NetWeightTON - sumWeight
    }
  }

  calculateNetWeight(rawData, subID) {
    if (Array.isArray(rawData)) {
      return Object.values(rawData)[subID]['NetWeightTON']
    } else {
      return rawData?.NetWeightTON
    }
  }
  renderTable(arr) {
    if (this.state.rawData) {
      // console.log(this.state.rawData)
      // console.log(description)
      // arr.sort((a, b) => { return a.subID - b.subID })
      let arrSubIDUnique = []
      arr.map((data) => { arrSubIDUnique.push(data.subID) })
      // console.log(arrSubIDUnique)
      arrSubIDUnique = [...new Set(arrSubIDUnique)]
      // console.log(arrSubIDUnique)
      arrSubIDUnique.sort((a, b) => { return a - b })
      return arrSubIDUnique.map((subID, idx) => {
        // console.log(Object.values(this.state.rawData[idx])[0])
        // console.log(subID)
        // let description = Object.values(this.state.rawData)[0].description
        // console.log(description)
        // description = Object.values(description).filter((o) => { return o.licenseID == this.state.licenseID })  
        let desArr = []
        // console.log(this.state.rawData)
        // console.log(this.state.rawData.length)
        // arr = arr.filter(o => o.subID == subID)
        arr.map((dataInside, idy) => {
          let newData = {
            ...Object.values(this.state.rawData[idy])[0],
            checkweightData: dataInside
          }
          desArr.push(newData)
        })
        if (desArr.length > 0) {
          let vehicleKey = 'k'
          return (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>ชื่อผู้ส่งออก <br /> อ.2 รายการที่ {parseInt(subID) + 1}</th>
                  <th>คำสั่งจ่ายงาน</th>
                  <th>วันที่ตรวจบรรทุก</th>
                  <th>เรือใหญ่</th>
                  <th>โกดัง</th>
                  <th>จังหวัด</th>
                  <th>ชนิดข้าว</th>
                  <th>น้ำหนัก/ตัน</th>
                  <th>ประเทศปลายทาง</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  return (desArr.map((insideSubData, idz) => {
                    let desIndex = 0
                    if (insideSubData['checkweightData']['subID'] == subID) {
                      if (Object.keys(insideSubData).indexOf('godown') != -1){
                        Object.values(insideSubData['description']).filter((o, desIDX) => {
                          if (o.licenseID == this.state.licenseID && o.subID == subID) {
                            desIndex = desIDX
                            Object.keys(o).map((e) => {
                              if (e.indexOf('vehicleName') != -1) {
                                vehicleKey = e
                              }
                            })
                          }
                        })
                      
                      let vehicleDescription = ''
                      vehicleDescription = insideSubData['description'][desIndex][vehicleKey]

                      Object.keys(insideSubData['checkweightData']).map((checkwegihtName) => {
                        if (checkwegihtName.indexOf('vehicleName') != -1) {
                          vehicleDescription = insideSubData['checkweightData'][checkwegihtName]
                        }
                      })

                      return <tr id={idx} >
                        <td>{insideSubData['companyID']}</td>
                        <td>{insideSubData['checkweightData']['jobID']}</td>
                        <td>{insideSubData['checkweightData']['shippingDate']}</td>
                        <td>{vehicleDescription}</td>
                        <td>{insideSubData['surveyLocateName']}</td>
                        <td>{insideSubData['surveyProvince']}</td>
                        <td>{insideSubData['description'][desIndex]['riceTypeName']}</td>
                        <td>{addCommaInNumber((parseFloat(insideSubData['checkweightData']['quantity']) / 1000).toFixed(4))}</td>
                        <td>{insideSubData['description'][desIndex]['destinationCity']}</td>
                      </tr>
                    }
                  }}))
                })()}
                <tr  >
                  <td>{ }</td>
                  <td>{ }</td>
                  <td>{ }</td>
                  <td>{ }</td>
                  <td>{ }</td>
                  <td> <b> น้ำหนักสุทธิ </b></td>
                  <td> {addCommaInNumber(this.calculateNetWeight(this.state.rawLicenseData['PaperlessDetail']['LicenseDetail'], subID).toFixed(4))} </td>
                  <td> <b> ยอดคงเหลือ</b> </td>
                  <td> {addCommaInNumber(this.calculateWeightLeft(this.calculateSumWeight(desArr, subID), this.state.rawLicenseData['PaperlessDetail']['LicenseDetail'], subID)?.toFixed(4))}</td>
                </tr>
              </tbody>
            </Table>
          )
        } else {
          // console.log(this.state.rawData)
          let rawObj = Object.values(this.state.rawData[idx])[0]
          let rawSubData = ''
          // console.log(rawObj)
          return (
            <Table bordered hover>
              <thead>
                <tr>
                  <th>ชื่อผู้ส่งออก <br /> อ.2 รายการที่ {parseInt(subID) + 1}</th>
                  <th>คำสั่งจ่ายงาน</th>
                  <th>วันที่ตรวจบรรทุก</th>
                  <th>เรือใหญ่</th>
                  <th>โกดัง</th>
                  <th>จังหวัด</th>
                  <th>ชนิดข้าว</th>
                  <th>น้ำหนัก/ตัน</th>
                </tr>
              </thead>
              <tbody>
                <tr id={idx} >
                  <td>{rawObj['companyID']}</td>
                  <td>{rawSubData[idx]['jobID']}</td>
                  <td>{this.renderDate(rawSubData[idx]['shippingDate'])}</td>
                  <td>-</td>
                  <td>{rawObj?.surveyLocateName}</td>
                  <td>{rawObj?.surveyProvince}</td>
                  <td>-</td>
                  <td>{addCommaInNumber((parseFloat(rawSubData[idx]['quantity']) / 1000).toFixed(4))}</td>
                </tr>
              </tbody>
            </Table>
          )
        }
      })
    }
  }
  renderDate(dateObj) {
    let dateParser = new Date(dateObj)
    let day = dateParser.getDate()
    let month = dateParser.getMonth() + 1
    let years = dateParser.getFullYear() + 543
    return `${day}/${month}/${years}`
  }
  saveNote(noteData, licenseID) {
    axios.post(
      'https://backend1.riceinspections.com/createNoteLicense',
      {
        data: {
          "licenseID": licenseID,
          "noteData": noteData
        }
      }
    ).then((res) => {
      console.log(res)
    })
  }
  render() {
    if (this.state.history) {
      return (
        <Container>
          <AdminNav></AdminNav>
          <Form>
            <Form.Row>
              <Form.Group as={Col} md="3">
                <Form.Control type="text" placeholder="เลขที่ใบอนุญาต" onChange={this.handleHistorySearch} >
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง
                </Form.Control.Feedback>
              </Form.Group>
              <Button variant="success" onClick={this.handleHistorySearchSubmit}>ค้นหา</Button>
            </Form.Row>
          </Form>
          {this.renderTable(this.state.history)}
          {this.renderExtra(this.state.history)}
        </Container>
      )
    }
    else {
      return (<Container>
        <AdminNav></AdminNav>
        <Form>
          <Form.Row>
            <Form.Group as={Col} md="3">
              <Form.Control type="text" placeholder="เลขที่ใบอนุญาต" onChange={this.handleHistorySearch} >
              </Form.Control>
              <Form.Control.Feedback type="invalid">
                กรุณากรอกเลขที่ใบอนุญาตให้ถูกต้อง
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="success" onClick={this.handleHistorySearchSubmit}>ค้นหา</Button>
          </Form.Row>
        </Form>
      </Container>)
    }
  }
}



export default Requested;
